export const analyzeFiltersCards = (data: any[]): any[] => {
  const grouped: Record<number, any[]> = {};

  data.forEach((item) => {
    if (!grouped[item.cod_campo]) {
      grouped[item.cod_campo] = [];
    }
    grouped[item.cod_campo].push(item);
  });

  const result: any[] = [];

  Object.values(grouped).forEach((items) => {
    if (items.length > 1) {
      const hasIsBlock = items.some((item) => 'isBlock' in item);
      if (hasIsBlock) {
        const hasTrueIsBlock = items.some((item) => item.isBlock);
        if (hasTrueIsBlock) {
          const filteredItem = items.find((item) => !('des_valor_2' in item));
          if (filteredItem) {
            result.push(filteredItem);
          }
        } else {
          result.push(items[0]);
        }
      } else {
        result.push(...items);
      }
    } else {
      result.push(items[0]);
    }
  });

  return result;
};
